import { RootState } from '../../../config';

export const selectReports = (state: RootState): any =>
  state.userData.reports.entities;

export const selectDisplayReports = (state: RootState): any =>
  state.userData.reports.display;

export const selectSelectedReport = (state: RootState): any =>
  state.userData.reports.selected;

export const selectReportsLoading = (state: RootState): boolean =>
  state.userData.reports.loading;
